import React, { useState, useEffect } from "react";
import "./ForgotPassword.css";
import logo from "../images/download.svg";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabase";
import image1 from "../images/dark-green-pickleball-court.jpg";
import image2 from "../images/padel-court.jpg";

const slideshowImages = [image1, image2];

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [titlePrefix, setTitlePrefix] = useState("Pickle");
  const [scrollDirection, setScrollDirection] = useState("down");

  // Auto-cycle the slideshow every 5 seconds, skipping the first immediate execution
  useEffect(() => {
    let isFirstRun = true;

    const interval = setInterval(() => {
      if (isFirstRun) {
        isFirstRun = false;
        return; // Skip the first execution
      }

      setCurrentSlide((prevSlide) => (prevSlide + 1) % slideshowImages.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slideshowImages.length]);

  // Sync titlePrefix and scrollDirection with the current slide
  useEffect(() => {
    const newTitlePrefix = currentSlide === 0 ? "Pickle" : "Padel";
    const newDirection = currentSlide === 0 ? "down" : "up";
    setTitlePrefix(newTitlePrefix);
    setScrollDirection(newDirection);
  }, [currentSlide]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);
    setSuccess(null);

    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/reset-password`,
      });

      if (error) {
        console.error("Error sending password reset email:", error);
        setError(`Failed to send reset email: ${error.message}`);
        return;
      }

      setSuccess("Password reset email sent! Please check your inbox.");
    } catch (error) {
      console.error("Unexpected error during password reset:", error);
      setError("An unexpected error occurred. Please try again.");
    }
  };

  const handleLogoClick = () => {
    // //console.log("ForgotPassword.js: handleLogoClick called");
    const defaultState = {
      selectedBookingType: "Bookings",
      selectedProfile: false,
      selectedSport: null,
      selectedDate: null,
      selectedCourtType: null,
      selectedCourt: null,
      selectedTimeslots: [],
    };
    // //console.log("ForgotPassword.js: Navigating to / with state:", defaultState);
    navigate("/", { state: defaultState });
  };

  return (
    <div className="forgot-password-page-container forgot-password-page">
      {/* Left Section (Slideshow) */}
      <div className="forgot-password-left-section">
        <div className="slideshow">
          {slideshowImages.map((image, index) => (
            <div
              key={index}
              className={`slide ${index === currentSlide ? "active" : ""}`}
              style={{
                backgroundImage: `url(${
                  typeof image === "string" ? image : image.default
                })`,
              }}
            ></div>
          ))}
        </div>
      </div>

      {/* Right Section (Form Area) */}
      <div className="forgot-password-right-section">
        <div
          className="logo-container"
          onClick={handleLogoClick}
          style={{ cursor: "pointer" }}
        >
          <img
            src={logo}
            alt="PickleDepot/PadelDepot Logo"
            className="forgot-password-logo"
          />
        </div>
        <div className="title-wrapper">
          <div className="title-container">
            <h2 className="forgot-password-title">
              <span className="title-prefix-wrapper">
                <span className={`title-prefix ${scrollDirection}`}>
                  <span className="title-prefix-item">Pickle</span>
                  <span className="title-prefix-item">Padel</span>
                  <span className="title-prefix-item">Pickle</span>
                </span>
              </span>
              <span className="title-suffix">Depot</span>
            </h2>
          </div>
        </div>
        {error && <p className="forgot-password-error">{error}</p>}
        {success && <p className="forgot-password-success">{success}</p>}
        <form className="forgot-password-form" onSubmit={handleSubmit}>
          <div className="forgot-password-form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              className="forgot-password-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Enter your email"
            />
          </div>
          <button
            type="submit"
            className="forgot-password-button"
            aria-label="Send password reset email"
          >
            Send Reset Email
          </button>
        </form>
        <p className="forgot-password-login-link">
          Remember your password?{" "}
          <a href="/login" className="forgot-password-link">
            Login Here
          </a>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;
